<template>
    <div style="display: flex; flex-direction: column;">
        <div @click="confirmClose" style="padding: 16px 20px; width: 100px; color: #808080; font-weight: 700;">닫기</div>
        <div style="flex: 1; padding: 0 20px;">
            <div style="text-align: center; margin-top: 27px;">
                <img v-if="isFirst" style="width: 140px;" :src="require('@/assets/img/welcome.png')" alt="">
                <img v-else style="width: 173px;" :src="require('@/assets/img/unlock.png')" alt="">
            </div>
            <div v-if="isFirst" style="text-align: center;">
                <div style="font-size: 32px;font-weight: 700;line-height: 46px;">돌아올줄 알았어요!</div>
                <div style="font-weight: 500;line-height: 24px;">정보 입력 후 회원으로 활동할 수 있습니다!</div>
            </div>
            <div v-else style="text-align: center;">
                <div style="font-size: 32px;font-weight: 700;line-height: 46px;">안되는 서비스 해방하기</div>
                <div style="font-weight: 500;line-height: 24px;">이런, 일부 서비스가 제한되었습니다.<br>회원정보 입력 후 모든 서비스를 이용할 수 있습니다.</div>
            </div>
            <div @click="showRegistStepTwo" style="text-align: center; margin-top: 40px; background-color: #210f03; height: 48px; border-radius: 12px; line-height: 48px; font-weight: 500; color: #fff; font-size: 14px;">내 계정 완성하기</div>
        </div>
    </div>
</template>

<script>
import { REGIST_STEP, MEMBER_TYPE } from "@/Constants"

export default {
    name: 'WelcomeBack',
    props: {
        isWriteDefaultInfo: {
            type: Boolean,
            default: true
        },
        isFirst: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            REGIST_STEP: REGIST_STEP,
            registInfo: {
                phone: null,
                name: null,
                birthday: null,
                sex: null,
                region_name: null,
                visit_hobby: null,
                career: null
            }
        }
    },
    methods: {
        checkBasicInfo() {
            const isExistPhone = this.$GlobalStore.loginInfo().phone
            const isExistName = this.$GlobalStore.loginInfo().name
            const isExistBirth = this.$GlobalStore.loginInfo().birthday
            const isExistSex = this.$GlobalStore.loginInfo().sex
            const isExistRegion = {
                address: this.$GlobalStore.loginInfo().place_address,
                gps_latitude: this.$GlobalStore.loginInfo().place_gps_latitude,
                gps_longitude: this.$GlobalStore.loginInfo().place_gps_longitude,
                id: this.$GlobalStore.loginInfo().place_id,
                name: this.$GlobalStore.loginInfo().place_name,
            }
            const isExistPurpose = this.$GlobalStore.loginInfo().visit_reason
            const isExistCareer = this.$GlobalStore.loginInfo().career
            const isExistLevel = this.$GlobalStore.loginInfo().level
            const isExistCoachType = this.$GlobalStore.loginInfo().coach_type
            // const purpose = {
            //     selectedHobby: this.$GlobalStore.loginInfo().visit_hobby,
            //     selectedLessonType: this.$GlobalStore.loginInfo().visit_lesson_type,
            //     selectedEtc: this.$GlobalStore.loginInfo().visit_etc,
            //     selectedEliteCourse: this.$GlobalStore.loginInfo().visit_elite_course,
            // }
            this.registInfo = {
                phone: isExistPhone ? isExistPhone : null,
                name: isExistName ? isExistName : null,
                birth: isExistBirth ? isExistBirth.replaceAll('-', '. ') : null,
                sex: isExistSex ? isExistSex + '성' : null,
                region: isExistRegion ? isExistRegion : null,
                ...(this.$GlobalStore.loginInfo().is_temp_coach == 0
                    ? {
                        lengthOfPlay: isExistCareer ? isExistCareer : null,
                        skill: isExistLevel ? isExistLevel : null,
                        purpose: isExistPurpose ? isExistPurpose : null,
                        register_type: MEMBER_TYPE.USER
                    }
                    : {
                        coach_type: isExistCoachType ? isExistCoachType : null,
                        register_type: MEMBER_TYPE.COACH
                    }
                )
            };

            if (this.$GlobalStore.loginInfo().is_temp_coach == 0) {
                if (!isExistPhone) {
                    return [REGIST_STEP.PHONE, 2]
                } else if (!isExistName) {
                    return [REGIST_STEP.NAME, 3]
                } else if (!isExistBirth) {
                    return [REGIST_STEP.BIRTHDAY, 4]
                } else if (!isExistSex) {
                    return [REGIST_STEP.SEX, 5]
                } else if (!isExistRegion.id) {
                    return [REGIST_STEP.REGION, 6]
                } else if (!isExistPurpose) {
                    return [REGIST_STEP.PURPOSE, 7]
                } else if (!isExistCareer) {
                    return [REGIST_STEP.SKILL, 8]
                }
            } else {
                if (!isExistPhone) {
                    return [REGIST_STEP.PHONE, 2]
                } else if (!isExistName) {
                    return [REGIST_STEP.NAME, 3]
                } else if (!isExistBirth) {
                    return [REGIST_STEP.BIRTHDAY, 4]
                } else if (!isExistSex) {
                    return [REGIST_STEP.SEX, 5]
                } else if (!isExistRegion.id) {
                    return [REGIST_STEP.REGION, 6]
                } else if (!isExistCoachType) {
                    return [REGIST_STEP.EXPERT_INFO, 7]
                }
            }
        },
        showRegistStepTwo() {
            const type = this.checkBasicInfo()
            this.$GlobalStore.addModal('SignupCommonFrame', { step: type[0], isShowNextBtn: type === REGIST_STEP.PHONE ? false : true, mode: 'update', receivedRegistInfo: this.registInfo, progress: type[1] })
        },
        confirmClose() {
            const html = `<div style="color: #210F03; padding: 20px 0px 20px 0px; border-bottom:1px solid #EBEBEB; font-weight:bold; font-size:16px;">회원 정보를 입력해주세요</div><div style="padding:0px 14px; line-height: 20px; font-size:14px;"><br>포지션 찾기 등의 서비스 사용을 위해<br>회원정보를 모두 입력해주세요</div>`
            this.$GlobalStore.showConfirm(html, () => {
                this.showRegistStepTwo()
            }, '입력하기', '취소하기', this.$GlobalStore.CONFIRM_TYPE.VERSION4, false, () => { this.$GlobalStore.closeLastModal() })
        }
    }
}
</script>